import { z } from 'zod';
export const dependencyCheckSchema = z.object({
    status: z.enum(['ok', 'error']),
    latencyMs: z.number().nonnegative().optional(),
    /** Cause courte et générique (« timeout », « unreachable »), jamais de secret ni d'URL. */
    error: z.string().optional(),
});
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'error']),
    version: z.string(),
    checks: z.object({
        app: dependencyCheckSchema,
        postgres: dependencyCheckSchema,
        redis: dependencyCheckSchema,
        livekit: dependencyCheckSchema,
    }),
});
//# sourceMappingURL=health.js.map